class NavHelper {
  static getSlugUrl(base: 'post' | 'category', slug: string): string {
    return `/${base}/${slug}`;
  }
}

export default NavHelper;
